import { WebhookGatewayMessage } from '../../../../../types/WebhookMessages';
import { useToasts } from '../../../../cdl/Toast/useToasts';
import { DeleteConfirmPopup } from '../../../../common/DeleteConfirmPopup/DeleteConfirmPopup';
import { translate } from '../../../../common/helpers/translate.helper';
import { useWebhookDelete } from '../hooks/useWebhookDelete';

interface WebhookDeleteModalProps {
    webhook: WebhookGatewayMessage;
    isOpen: boolean;
    onDismiss: () => void;
}

export const WebhookDeleteModal = ({ webhook, isOpen, onDismiss }: WebhookDeleteModalProps) => {
    const webhookDeleteMutation = useWebhookDelete();
    const { addErrorToast } = useToasts();

    const handleDeleteConfirm = () => {
        webhookDeleteMutation.mutate(webhook.id, {
            onSuccess: () => {
                onDismiss();
            },
            onError: () => {
                addErrorToast(translate('global.genericToastError'));
            },
        });
    };

    return (
        <DeleteConfirmPopup
            isOpen={isOpen}
            onSubmit={handleDeleteConfirm}
            onDismiss={onDismiss}
            headline={translate('webhooks.deleteConfirmPopup.deleteDestination')}
            text={translate('webhooks.deleteConfirmPopup.text')}
            deleteButtonText={translate('webhooks.deleteConfirmPopup.deleteDestination')}
            itemToDelete={webhook.name}
            isSubmitting={webhookDeleteMutation.isPending}
        />
    );
};
